import React from 'react'

import Publication from '/react4xp/components/pages/publication'

import { PublicationLayoutProps } from './publication.d'

function PublicationLayout(props: PublicationLayoutProps) {
    return (
        <Publication {...props} />
    )
}

export default (props) => <PublicationLayout {...props} />
